import React, { useRef, useCallback } from 'react';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { useToast } from 'hooks/toast';
import * as Yup from 'yup';
import typeInvolvement from 'utils/typeInvolvement';
import handcuffs from 'utils/handcuffs';
import Simple from 'components/Headers/Simple';
import { AiOutlineFileText } from 'react-icons/ai';
import { parseDate } from 'utils';
import getValidationError from '../../../../utils/getValidationsErros';

/** hooks */
import { useHttp } from '../../../../hooks/http';
import {
  WrapperLabel, Select, Button, Input, InputMask,
} from '../../../../components/Forms';
import { UserFriends } from '../../../../styles/icons';
import {
  Container, GridButtons, WrapperBtnCancel, WrapperBtnSubmit, WrapperAddress, Title,
} from './styles';
import Layout from '../../../../components/Layout';

/** Options Select */

const StoreInvolved: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { httpPost } = useHttp();
  const history = useHistory();
  const { addToast } = useToast();
  const ROId = localStorage.getItem('ROId');

  const handleSubmit = useCallback(async (data: any) => {
    const involvedd = {
      ...data,
      bopm_id: ROId,
      type_involvement: data.type_involvement ? data.type_involvement?.map((type:any) => type.value).join(',') : null,
      handcuffs: data.handcuffs?.value,
      qualified: data.qualified,
      name: data.name,
      birthday: parseDate(data.birthday),
      document_secondary: data.document_secondary,
      document: data.document,
      phone: data.phone,
      mather: data.mather,
      situation: data.situation?.value,
    };

    try {
    formRef.current?.setErrors({});
    const schema = Yup.object().shape({

      type_involvement: Yup.string().typeError('Tipo de envolvimento é obrigatório ter no mínimo 1(um)'),
      handcuffs: Yup.string().required('Motivação é obrigatório'),
      qualified: Yup.string().required('Qualificador é obrigatório'),
      name: Yup.string().required('Nome é obrigatório'),
      birthday: Yup.date().typeError('Data é obrigatório ou está errada'),
      mather: Yup.string().required('Mãe é obrigatório'),
      situation: Yup.string().required('Situação é obrigatório'),

    });
    await schema.validate(involvedd, { abortEarly: false });

    const { status } = await httpPost('involveds', involvedd);

    if (status === 200) {
      addToast({ title: 'Salvo com sucesso!', type: 'success' });
      history.push('/RO/involveds/show');
    } else {
      addToast({ title: 'Não foi possível gravar!', type: 'error' });
    }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
        formRef.current?.setErrors(erros);
      }
    }
  }, [addToast, ROId, history, httpPost]);

  const breadcrumbs = {
    icon: UserFriends,
    links: [{ path: '/RO/step/1', title: 'RO-SP / Envolvidos/ Cadastrar' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <Simple>
          <Title>
            <AiOutlineFileText />Cadastrar Envolvidos
          </Title>
        </Simple>
        <WrapperAddress>
          <Container>
            <UForm ref={formRef} onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <WrapperLabel label="Qualificador" xs={12} md={2} sm={2}>
                  <InputMask
                    name="qualified"
                    mask="Q99"
                    placeholder="QXX"
                  />
                </WrapperLabel>

                <WrapperLabel label="Nome" xs={12} md={10} sm={10}>
                  <Input name="name" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Data de nascimento" xs={12} md={4} sm={4}>
                  <InputMask
                    name="birthday"
                    mask="99/99/9999"
                  />
                </WrapperLabel>

                <WrapperLabel label="Mãe" xs={12} md={8} sm={8}>
                  <Input name="mather" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="CPF" xs={12} md={4} sm={4}>
                  <InputMask
                    name="document"
                    mask="999.999.999-99"
                    style={{ textTransform: 'uppercase' }}
                  />
                </WrapperLabel>

                <WrapperLabel label="RG" xs={12} md={4} sm={4}>
                  <Input name="document_secondary" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Celular" xs={12} sm={4} md={4}>
                  <InputMask mask="(99) 99999-9999" name="phone" />
                </WrapperLabel>

                <WrapperLabel label="Motivo das algemas" xs={12} md={4} sm={4}>
                  <Select
                    name="handcuffs"
                    options={handcuffs}
                  />
                </WrapperLabel>

                <WrapperLabel label="Tipo de envolvimento" xs={12} md={4} sm={4}>
                  <Select
                    name="type_involvement"
                    options={typeInvolvement}
                    isMulti
                  />
                </WrapperLabel>

                <WrapperLabel label="Situação" xs={12} md={4} sm={4}>
                  <Select
                    name="situation"
                    options={[
                      { value: 'PRESO', label: 'PRESO' },
                      { value: 'APREENDIDO', label: 'APREENDIDO' },
                      { value: 'LIBERADO', label: 'LIBERADO' },
                    ]}
                  />
                </WrapperLabel>
              </Grid>
              <GridButtons>
                <WrapperBtnCancel>
                  <Button
                    type="button"
                    onClick={() => { history.push('/RO/step/1'); }}
                  >
                    Cancelar
                  </Button>
                </WrapperBtnCancel>
                <WrapperBtnSubmit>
                  <Button
                    type="submit"
                  >
                    Salvar
                  </Button>
                </WrapperBtnSubmit>
              </GridButtons>
            </UForm>
          </Container>
        </WrapperAddress>
      </Container>
    </Layout>
  );
};

export default StoreInvolved;
